import { createTheme } from '@mui/material';
import { esES as dataGridesES } from '@mui/x-data-grid';
import { esES } from '@mui/material/locale';

/**
 * MUI theme aligned with `rapidash/src/theme/index.ts` so this app blends
 * into the rapidash dashboard shell when iframed.
 *
 * @see https://mui.com/material-ui/customization/theming/
 */
const FONT_FAMILY = ['"Inter Variable"', 'Inter', 'sans-serif'].join(',');
const TEXT_COLOR = '#515151';

export const theme = createTheme(
  {
    palette: {
      primary: {
        main: '#6150AD',
        light: '#CABEFF',
        dark: '#1C0062',
        contrastText: '#FFFFFF',
      },
      secondary: {
        main: '#1ABC9C',
      },
      info: { main: '#0288D1' },
      background: { default: '#F7F6FD' },
      text: { primary: TEXT_COLOR },
    },
    typography: {
      fontFamily: FONT_FAMILY,
      h1: { fontSize: '29px', fontWeight: 600, color: TEXT_COLOR },
      h2: { fontSize: '20px', fontWeight: 600, color: TEXT_COLOR },
      h3: { fontSize: '16px', fontWeight: 600, color: TEXT_COLOR },
      h4: { fontSize: '16px', fontWeight: 400, color: TEXT_COLOR },
      body1: { fontSize: '14px', fontWeight: 400, color: TEXT_COLOR },
      caption: { fontSize: '14px', fontWeight: 400 },
      button: { textTransform: 'none' },
    },
    components: {
      MuiInputLabel: {
        styleOverrides: {
          root: { color: TEXT_COLOR, fontWeight: 'bold', fontSize: '15px' },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'inherit',
            borderRadius: '12px',
            paddingLeft: 24,
            paddingRight: 24,
            boxShadow: 'none',
            minHeight: '40px',
          },
        },
      },
      MuiDataGrid: {
        styleOverrides: {
          root: { color: TEXT_COLOR, fontFamily: FONT_FAMILY },
          columnHeaderTitle: { fontWeight: 700, fontSize: '13px' },
        },
      },
      MuiMenuItem: {
        styleOverrides: { root: { color: TEXT_COLOR, fontSize: '14px' } },
      },
      MuiOutlinedInput: {
        styleOverrides: { root: { color: TEXT_COLOR, borderRadius: 8 } },
      },
    },
  },
  esES,
  dataGridesES
);
